import {createAction, handleActions} from 'redux-actions';
import {Api} from '../../api/api';
import _ from 'lodash';
import {fetchSubmitForm, fetchSubmitFormFailed, fetchSubmitFormSuccess} from "../common/submitForm";
import { logout, onForbidden } from '../account/login';

//- Actions
export const fetchGetPriorConsentsFailed = createAction('FETCH_GET_PRIOR_CONSENTS_FAILED');
export const fetchGetPriorConsentsSuccess = createAction('FETCH_GET_PRIOR_CONSENTS_SUCCESS');
export const fetchGetPriorConsents = createAction(
    'FETCH_GET_PRIOR_CONSENTS',
    (date) => Api.getPriorConsents(date),
    () => ({
        apiCall: true,
        onSuccess: fetchGetPriorConsentsSuccess,
        onFail: fetchGetPriorConsentsFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onGetPriorConsents = () => (dispatch, getState) => {
    let filterDate = getFilterDate(getState());

    dispatch(fetchGetPriorConsents(filterDate));
};

export const onCreatePriorConsent = (data) => (dispatch) => {
    dispatch(fetchSubmitForm());
    dispatch(fetchCreatePriorConsent(data));
};

export const fetchCreatePriorConsent = createAction(
    'FETCH_CREATE_PRIOR_CONSENT',
    (data) => Api.createPriorConsent(data),
    () => ({
        apiCall: true,
        onSuccess: fetchSubmitFormSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const setFilterDate = createAction('SET_FILTER_DATE');

export const resetPriorConsentsData = createAction('RESET_PRIOR_CONSENTS_DATA');

//- State
const initialState = {
    data: null,
    error: null,
    fetching: false,
    dateFilter: null
};

//- Reducers
export default handleActions({
    FETCH_GET_PRIOR_CONSENTS: (state) => {
        return {...state, data: null, error: null, fetching: true};
    },
    FETCH_GET_PRIOR_CONSENTS_FAILED: (state, action) => {
        return {...state, data: null, error: action.payload, fetching: false};
    },
    FETCH_GET_PRIOR_CONSENTS_SUCCESS: (state, action) => {
        return {...state, data: action.payload.content, error: null, fetching: false};
    },
    SET_FILTER_DATE: (state, action) => {
        return {...state, dateFilter: action.payload};
    },
    RESET_PRIOR_CONSENTS_DATA: (state) => {
        return {...state, data: null, dateFilter: null, error: null}
    }
}, initialState);

//- Selectors
export const getPriorConsents = state => state.priorConsents;

export const loadingPriorConsents = state => getPriorConsents(state).fetching;

export const getPriorConsentsData = state => getPriorConsents(state).data;

export const getPriorConsentsList = state => {
    return _.map(getPriorConsentsData(state), consent => ({
        id: consent.id,
        targetType: consent.targetType,
        targetId: consent.targetId,
        metadata: consent.metadata,
        enabledTill: consent.enabledTill,
        grantedPeriodDays: consent.grantedPeriodDays
    }))
};

export const getFilterDate = state => getPriorConsents(state).dateFilter;


// WEBPACK FOOTER //
// ./src/reducers/consent/priorConsents.js